export default __webpack_public_path__ + "static/10(1)-3cd320cc80a528bd3302ac65c74a5d87.png";